import _ from 'lodash';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  addUsersEventColumn,
  changeUsersEvent,
  deleteUsersEventColumn,
  setUsersEventColumnValue,
} from '../../../../../actions/dashboards/users';
import {
  getMetainf,
  getDashboardsUsersColumns,
  getDashboardsUsersEvent,
  getEventNames,
} from '../../../../../reducers/analyticsApp';
import UsersView from '../../../../../components/dashboards/cards/builder/users/UsersView';

const getColumns = ({ columns }) => columns;
const getMetainformation = ({ metainf }) => metainf;

const getAvailableUsersEventFields = createSelector(
  [getColumns, getMetainformation],
  (columns, metainf) => {
    const columnsValues = _(columns)
      .map((c) => c.value)
      .compact()
      .value();

    return {
      meta: _.omit(metainf.meta, columnsValues),
      groups: metainf.groups.map((g) => ({
        ...g,
        fields: g.fields.filter((f) => !columnsValues.includes(f.path)),
      })),
    };
  }
);

const getColumnsData = createSelector([getColumns, getMetainformation], (columns, metainf) => {
  const fields = _(metainf.groups).map('fields').flatten().value();
  return columns.map((c) => ({
    ...c,
    ...fields.find((field) => {
      return field.path === c.value;
    }),
  }));
});

const mapStateToProps = (state, { unit }) => {
  const event = getDashboardsUsersEvent(state, unit.id);
  const columns = getDashboardsUsersColumns(state, unit.id);
  const metainf = getMetainf(state, event);

  return {
    metainf: getAvailableUsersEventFields({ columns, metainf }),
    columns: getColumnsData({ columns, metainf }),
    event,
    events: getEventNames(state),
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  setUsersEventColumnValue: (id, value) => dispatch(setUsersEventColumnValue(unit.id, id, value)),
  deleteUsersEventColumn: (id) => dispatch(deleteUsersEventColumn(unit.id, id)),
  addUsersEventColumn: () => dispatch(addUsersEventColumn(unit.id)),
  changeUsersEvent: (e) => dispatch(changeUsersEvent(unit.id, e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersView);
